<template>
  <Card>
    <VRow v-if="!isLoadingFoundApplication">
      <VCol cols="12">
        <div class="d-flex flex-column align-center justify-center w-100 ga-3">
          <h1 class="text-title-color font-size-18 font-weight-700">Payment details</h1>
        </div>
      </VCol>
      <VCol v-if="fountApplicationFullName" cols="12">
        <div class="review-input">
          <div class="review-input__label">Name</div>
          <div class="review-input__value">{{ fountApplicationFullName }}</div>
        </div>
      </VCol>
      <VCol cols="12">
        <div class="review-input">
          <div class="review-input__label">Email</div>
          <div class="review-input__value">{{ foundApplication.email }}</div>
        </div>
      </VCol>
      <VCol cols="12">
        <div class="review-input">
          <div class="review-input__label">Current Address</div>
          <div class="review-input__value">{{ fountApplicationFullAddress }}</div>
        </div>
      </VCol>
      <VCol cols="12" v-if="foundApplication.isAnnualOrNotAnnualApp">
        <VAlert border>
          <label class="d-flex align-center mb-2 text-title-color font-weight-800">Please Choose a Service</label>
          <VRadioGroup v-model="stageOption" :disabled="isPayLoading">
            <VRadio
              label="Bundle: Reapplication + 12 Months of Pension Keeper"
              :value="'Bundle'"
              color="primary"
            ></VRadio>
            <VRadio label="Standalone: Reapplication only" :value="'Standalone'" color="primary"></VRadio>
          </VRadioGroup>
          <div><b>Price:</b> {{ currencySymbol }}{{ formatAmount(amount) }}</div>
        </VAlert>
      </VCol>
      <VCol cols="12">
        <div>
          <VSelect
            label="Which Agent Did You Speak to?"
            :items="agentsOptions"
            v-model="agent"
            variant="outlined"
            :disabled="isPayLoading"
            class="custom-input"
          >
          </VSelect>
        </div>
      </VCol>
      <VCol cols="12">
        <template v-if="!isUpdatePaymentMethod">
          <div v-if="isShowPayNow" class="review-input my-3">
            <div class="credit-card">
              <div class="d-flex gap-16">
                <VIcon icon="mdi-credit-card" size="small"></VIcon>
                <div>{{ 'XXXX XXXX XXXX ' + foundApplication.cardData.last4Digits }}</div>
              </div>
              <div>{{ foundApplication.cardData.expireMonth + '/' + foundApplication.cardData.expireYear }}</div>
            </div>
          </div>
          <div class="d-flex align-center justify-center w-100 gap-10">
            <button
              v-if="isShowPayNow"
              class="main-btn"
              @click="handlePayNow()"
              :disabled="isLoadingPayNow || isPayLoading"
            >
              Pay Now {{ currencySymbol }}{{ formatAmount(amount) }}
            </button>
            <button
              class="main-btn"
              @click="handleSelectCountry({ name: this.foundApplication.currentAddress.countryCode })"
              :disabled="isLoadingPayNow || isPayLoading"
            >
              Update your Payment Method
            </button>
          </div>
          <div v-if="isShowPayNow" class="input-helptext text-center my-2">
            Click Pay Now Using previous CC details we've on file
          </div>
        </template>
      </VCol>
      <VCol cols="12">
        <template v-if="isUpdatePaymentMethod">
          <template v-if="isStripeLoaded">
            <VForm ref="formPayRef" v-model="formValid" @submit.prevent>
              <VRow>
                <VCol cols="12">
                  <div class="text-title-color font-size-16 font-weight-600 mb-3">Personal Details</div>
                  <div id="address-element"></div>
                </VCol>
                <VCol cols="12">
                  <label>Card Number</label>
                  <div id="card-element"></div>
                </VCol>
                <VCol cols="12">
                  <div class="d-flex flex-column align-center justify-center">
                    <VCheckbox v-model="isAgreeTermsConditions" :disabled="isPayLoading" :rules="formRules.terms">
                      <template v-slot:label>
                        <div>
                          I agree to XtraPension's
                          <a href="https://www.xtrapension.com/terms" target="_blank" v-bind="props" @click.stop>
                            Terms & Conditions</a
                          >
                        </div>
                      </template>
                    </VCheckbox>
                  </div>
                </VCol>
                <VCol cols="12">
                  <div v-if="isPayLoading" class="d-flex flex-column align-center justify-center py-4 w-100">
                    <VProgressCircular indeterminate color="primary" />
                  </div>
                  <div class="d-flex items-center justify-center w-100">
                    <button
                      class="main-btn"
                      :disabled="isPayLoading || !isAgreeTermsConditions || isLoadingPayNow"
                      @click="pay()"
                      type="submit"
                    >
                      Pay {{ currencySymbol }}{{ formatAmount(amount) }}
                    </button>
                  </div>
                  <div v-if="stripeValidationError" class="info-container info-container__red my-2">
                    <p>{{ stripeValidationError }}</p>
                  </div>
                </VCol>
              </VRow>
            </VForm>
          </template>
          <template v-else>
            <div class="d-flex flex-column align-center justify-center py-4 w-100">
              <VProgressCircular indeterminate color="primary" />
            </div>
          </template>
        </template>
      </VCol>
    </VRow>
    <VRow v-else>
      <div class="d-flex flex-column align-center justify-center py-4 w-100">
        <VProgressCircular indeterminate color="primary" />
      </div>
    </VRow>
  </Card>
</template>
<script>
import { mapActions } from 'vuex';
// Service
import StripeService from '@/services/stripe-service/stripe.service';
import ReapplyService from '@/services/reapply-service/reapply.service';
// Componens
import Card from '@/components/common/Card/Card.vue';
export default {
  inject: ['agentsOptions'],
  components: {
    Card
  },
  computed: {
    isShowPayNow() {
      return (
        this.foundApplication?.customerId &&
        this.foundApplication?.paymentMethod &&
        this.foundApplication?.cardData?.last4Digits &&
        this.foundApplication?.cardData?.expireMonth &&
        this.foundApplication?.cardData?.expireYear &&
        this.foundApplication?.currentAddress?.countryCode
      );
    },
    fountApplicationFullName() {
      return this.foundApplication.firstName + ' ' + this.foundApplication.lastName;
    },
    fountApplicationFullAddress() {
      const addressParts = [
        this.foundApplication.currentAddress?.street,
        this.foundApplication.currentAddress?.city,
        this.foundApplication.currentAddress?.state,
        this.foundApplication.currentAddress?.postalCode,
        this.foundApplication.currentAddress?.country
      ].filter((part) => part && part.trim() !== '');

      return addressParts.length > 0 ? addressParts.join(', ') : 'Address not provided';
    },
    currencyCode() {
      let currency = 'USD';
      if (this.isEuropeanCountry(this.countrySelected)) {
        currency = 'EUR';
      } else if (this.countrySelected === 'CA') {
        currency = 'CAD';
      } else if (this.countrySelected === 'US') {
        currency = 'USD';
      } else if (this.countrySelected === 'AU') {
        currency = 'AUD';
      } else if (this.countrySelected === 'NZ') {
        currency = 'NZD';
      } else if (this.countrySelected === 'ZA') {
        currency = 'ZAR';
      }
      return currency;
    },
    currencySymbol() {
      let currencySymbol = 'US $';
      if (this.isEuropeanCountry(this.countrySelected)) {
        currencySymbol = '€';
      } else if (this.countrySelected === 'CA') {
        currencySymbol = 'CA $';
      } else if (this.countrySelected === 'AU') {
        currencySymbol = 'AU $';
      } else if (this.countrySelected === 'NZ') {
        currencySymbol = 'NZ $';
      } else if (this.countrySelected === 'ZA') {
        currencySymbol = 'R';
      }
      return currencySymbol;
    },
    amount() {
      let amount = 0;
      if (this.isFoundApplication) {
        if (this.foundApplication?.isPensionKeeperCustomer === true) {
          amount = 35000; // 350 USD
          if (this.isEuropeanCountry(this.countrySelected)) {
            amount = 30000; // 300 EUR
          } else if (this.countrySelected === 'AU' || this.countrySelected === 'CA') {
            amount = 50000; // 500 CAD
          } else if (this.countrySelected === 'ZA') {
            amount = 550000; // 5500 R
          } else if (this.countrySelected === 'NZ') {
            amount = 60000; // 600 $
          }
        } else {
          if (this.stageOption === 'Bundle') {
            amount = 45000; // 450 USD
            if (this.isEuropeanCountry(this.countrySelected)) {
              amount = 40000; // 400 EUR
            } else if (this.countrySelected === 'AU' || this.countrySelected === 'CA') {
              amount = 65000; // 650 CAD
            } else if (this.countrySelected === 'ZA') {
              amount = 750000; // 7500 R
            } else if (this.countrySelected === 'NZ') {
              amount = 70000; // 700 $
            }
          } else {
            amount = 55000; // 550 USD
            if (this.isEuropeanCountry(this.countrySelected)) {
              amount = 50000; // 500 EUR
            } else if (this.countrySelected === 'AU' || this.countrySelected === 'CA') {
              amount = 80000; // 800 CAD
            } else if (this.countrySelected === 'ZA') {
              amount = 1000000; // 10000 R
            } else if (this.countrySelected === 'NZ') {
              amount = 90000; // 900 $
            }
          }
        }
      } else {
        amount = 55000; // 550 USD
        if (this.isEuropeanCountry(this.countrySelected)) {
          amount = 50000; // 500 EUR
        } else if (this.countrySelected === 'AU' || this.countrySelected === 'CA') {
          amount = 80000; // 800 CAD
        } else if (this.countrySelected === 'ZA') {
          amount = 1000000; // 10000 R
        } else if (this.countrySelected === 'NZ') {
          amount = 90000; // 900 $
        }
      }

      return amount;
    }
  },
  data() {
    return {
      recordId: null,
      isFoundApplication: false,
      foundApplication: {
        applicationId: '',
        applicationNumber: '',
        customerId: '',
        paymentMethod: '',
        cardData: {
          cardBrand: '',
          expireMonth: 0,
          expireYear: '',
          last4Digits: ''
        },
        dob: '',
        email: '',
        firstName: '',
        lastName: '',
        nationalInsuranceNumber: '',
        phone: '',
        isPensionKeeperCustomer: false,
        isAnnualOrNotAnnualApp: false,
        currentAddress: {
          city: '',
          country: '',
          countryCode: '',
          postalCode: '',
          state: '',
          street: ''
        }
      },
      isLoadingFoundApplication: false,
      stageOption: 'Bundle',
      isStripeLoaded: false,
      isPayLoading: false,
      isLoadingPayNow: false,
      isPayCompleted: false,
      isUpdatePaymentMethod: false,
      countrySelected: '',
      payCompletedId: null,
      stripe: null,
      cardElement: null,
      addressElement: null,
      fullName: null,
      firstName: null,
      lastName: null,
      shippingAddress: null,
      phone: null,
      email: '',
      stripeValidationError: '',
      tax: true,
      customer: null,
      latest_charge: null,
      isAgreeTermsConditions: false,
      customerId: null,
      todayDate: new Date().toISOString().slice(0, 10),
      formValid: false,
      agent: '',
      formRules: {
        required: [(v) => (v !== null && v !== undefined && !!v) || 'This field is required'],
        email: [(v) => !!v || 'Email required', (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'],
        terms: [(v) => !!v || 'Terms required']
      }
    };
  },
  mounted() {
    this.recordId = this.$route.params.id;
    this.getPaymentInfo(this.recordId);
  },
  methods: {
    ...mapActions('main', ['showSnackbar']),
    formatAmount(amount) {
      return amount / 100;
    },
    async getPaymentInfo(id) {
      this.isLoadingFoundApplication = true;
      try {
        const { status, paymentData } = await ReapplyService.getReapplyPaymentInfo(id);
        console.log('Get Payment Info Response', status, paymentData);
        if (status === 'success' && paymentData) {
          this.isLoadingFoundApplication = false;
          this.foundApplication = this.formatData(paymentData ?? {});
          this.email = this.foundApplication?.email ?? '';
          this.customerId = this.foundApplication?.customerId ? this.foundApplication.customerId : null;
          this.isFoundApplication = true;
          this.countrySelected = this.foundApplication.currentAddress.countryCode || '';
          this.firstName = this.foundApplication.firstName;
          this.lastName = this.foundApplication.lastName;
          this.phone = this.foundApplication.phone;
        } else {
          this.showSnackbar({ text: 'Oops, Something Went Wrong', color: 'red' });
        }
      } catch (err) {
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
        console.log(err);
      }
    },
    formatData(paymentData = {}) {
      return {
        applicationId: paymentData?.applicationId ?? '',
        applicationNumber: paymentData?.applicationNumber ?? '',
        customerId: paymentData?.customerId ?? '',
        paymentMethod: paymentData?.paymentMethod ?? '',
        cardData: {
          cardBrand: paymentData?.cardData?.cardBrand ?? '',
          expireMonth: paymentData?.cardData?.expireMonth ?? 0,
          expireYear: paymentData?.cardData?.expireYear ?? '',
          last4Digits: paymentData?.cardData?.last4Digits ?? ''
        },
        dob: paymentData?.dob ?? '',
        email: paymentData?.email ?? '',
        firstName: paymentData?.firstName ?? '',
        lastName: paymentData?.lastName ?? '',
        nationalInsuranceNumber: paymentData?.nationalInsuranceNumber ?? '',
        phone: paymentData?.phone ?? '',
        isPensionKeeperCustomer: paymentData?.isPensionKeeperCustomer ?? false,
        isAnnualOrNotAnnualApp: paymentData?.isAnnualOrNotAnnualApp ?? false,
        currentAddress: {
          city: paymentData?.currentAddress?.city ?? '',
          country: paymentData?.currentAddress?.country ?? '',
          countryCode: paymentData?.currentAddress?.countryCode ?? '',
          postalCode: paymentData?.currentAddress?.postalCode ?? '',
          state: paymentData?.currentAddress?.state ?? '',
          street: paymentData?.currentAddress?.street ?? ''
        }
      };
    },
    async handlePayNow() {
      this.isLoadingPayNow = true;
      try {
        const res = await StripeService.sendFormData({
          payment_method_id: this.foundApplication.paymentMethod,
          customerId: this.foundApplication.customerId,
          currency: this.currencyCode,
          amount: this.amount,
          email: this.foundApplication.email,
          setup_future_usage: false,
          description: 'Pension Keeper - Reapply',
          shiping_details: {
            name: this.fountApplicationFullName,
            phone: this.foundApplication.phone,
            address: {
              line1: this.foundApplication?.currentAddress?.street ?? '',
              city: this.foundApplication?.currentAddress?.city ?? '',
              state: this.foundApplication?.currentAddress?.state ?? '',
              country: this.foundApplication.currentAddress?.countryCode ?? '',
              postal_code: this.foundApplication.currentAddress?.postalCode ?? ''
            }
          }
        });
        this.shippingAddress = {
          line1: this.foundApplication?.currentAddress?.street ?? '',
          city: this.foundApplication?.currentAddress?.city ?? '',
          state: this.foundApplication?.currentAddress?.state ?? '',
          country: this.foundApplication.currentAddress?.countryCode ?? '',
          postal_code: this.foundApplication.currentAddress?.postalCode ?? ''
        };
        const paymentResponse = res;
        this.handleServerResponse(paymentResponse);
      } catch (err) {
        this.isLoadingPayNow = false;
        console.error(err);
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
      }
    },
    async handleSelectCountry(country) {
      this.isUpdatePaymentMethod = true;
      this.tax = country.isTax;
      this.countrySelected = country.name;
      this.showStripeLoading();
      try {
        // eslint-disable-next-line no-undef
        this.stripe = await Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
        await this.hideStripeLoading();
        this.createAndMountFormElements();
      } catch (err) {
        console.log(err);
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
      }
    },
    showStripeLoading() {
      this.isStripeLoaded = false;
    },
    hideStripeLoading() {
      this.isStripeLoaded = true;
    },
    async createAndMountFormElements() {
      const elements = this.stripe.elements();
      this.cardElement = elements.create('card', {
        hidePostalCode: true
      });
      this.cardElement.mount('#card-element');
      let options = {
        mode: 'billing',
        fields: {
          phone: 'always',
          name: 'auto'
        },
        display: {
          name: 'split'
        },
        validation: {
          phone: {
            required: 'always'
          }
        }
      };
      let defaultValues = {
        firstName: '',
        lastName: '',
        phone: '',
        address: {
          line1: '',
          city: '',
          state: '',
          country: '',
          postal_code: ''
        }
      };

      if (this.foundApplication?.firstName) {
        defaultValues.firstName = this.foundApplication?.firstName;
      }
      if (this.foundApplication?.lastName) {
        defaultValues.lastName = this.foundApplication?.lastName;
      }
      if (this.foundApplication?.phone) {
        defaultValues.phone = this.foundApplication?.phone;
      }
      if (this.foundApplication?.currentAddress) {
        defaultValues.address.line1 = this.foundApplication?.currentAddress?.street ?? '';
        defaultValues.address.city = this.foundApplication?.currentAddress?.city ?? '';
        defaultValues.address.state = this.foundApplication?.currentAddress?.state ?? '';
        defaultValues.address.country = this.foundApplication.currentAddress?.countryCode ?? '';
        defaultValues.address.postal_code = this.foundApplication.currentAddress?.postalCode ?? '';
      } else {
        const countryCode = this.formatCountryNameToCountryCode(this.countrySelected);
        if (countryCode) {
          defaultValues.address.country = countryCode;
        }
      }

      options = {
        ...options,
        defaultValues: defaultValues
      };
      this.addressElement = elements.create('address', options);
      this.addressElement.mount('#address-element');

      this.cardElement.on('change', this.setValidationCardError);
      this.addressElement.on('change', this.setValidationError);
    },
    setValidationCardError(event) {
      this.stripeValidationError = event.error ? event.error.message : '';
    },
    setValidationError(event) {
      const { error, address, name, firstName, lastName, phone } = event.value;
      this.stripeValidationError = error ? error?.message : '';
      if (event.complete) {
        this.shippingAddress = address;
        this.fullName = name;
        this.firstName = firstName;
        this.lastName = lastName;
        this.phone = phone;
      } else {
        this.shippingAddress = null;
        this.fullName = null;
        this.firstName = null;
        this.lastName = null;
        this.phone = null;
      }
      if (address?.country) {
        this.tax = this.isEuropeanCountry(address.country);
        this.countrySelected = address.country;
      }
    },
    async pay() {
      try {
        const { valid } = await this.$refs.formPayRef.validate();
        console.log('Valid', valid);
        if (valid) {
          if (this.fullName && this.phone && this.shippingAddress && this.email) {
            this.showPayLoading();
            const result = await this.stripe.createPaymentMethod({
              type: 'card',
              card: this.cardElement,
              billing_details: {
                name: this.fullName,
                email: this.email,
                phone: this.phone,
                address: this.shippingAddress
              }
            });

            this.stripePaymentMethodHandler(result);
          } else {
            this.stripeValidationError = 'Fill in your personal data!';
          }
        }
      } catch (err) {
        this.hidePayLoading();
        console.error(err);
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
      }
    },
    async stripePaymentMethodHandler(result) {
      try {
        const { error } = result;
        if (error) {
          this.stripeValidationError = error?.message ?? '';
          this.hidePayLoading();
        } else {
          const res = await StripeService.sendFormData({
            payment_method_id: result.paymentMethod.id,
            customerId: this.customerId,
            currency: this.currencyCode,
            amount: this.amount,
            email: this.email,
            setup_future_usage: false,
            shiping_details: {
              name: this.fullName,
              phone: this.phone,
              address: this.shippingAddress
            },
            description: 'Pension Keeper - Reapply'
          });
          const paymentResponse = res;
          this.handleServerResponse(paymentResponse);
        }
      } catch (err) {
        this.hidePayLoading();
        console.error(err);
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
      }
    },
    async handleServerResponse(response) {
      try {
        const { error, requires_action, payment_intent_client_secret } = response;
        if (error) {
          this.showSnackbar({ text: this.stripeValidationError, color: 'red' });
        } else if (requires_action) {
          const { error: errorAction, paymentIntent } = await this.stripe.handleCardAction(
            payment_intent_client_secret
          );
          if (errorAction) {
            // this.stripeValidationError = response.error.message;
          } else {
            const serverResponse = await await StripeService.sendFormData({
              payment_intent_id: paymentIntent.id
            });
            this.handleServerResponse(await serverResponse);
          }
        } else {
          const { id, status, paymentMethod, customer, latest_charge } = response;
          console.log('Payment ID', id);
          console.log('Status', status);
          console.log('Customer', customer);
          console.log('Latest charge', latest_charge);
          this.customer = customer;
          this.latest_charge = latest_charge;
          if (status === 'Success' && id && paymentMethod) {
            this.createApplication(id, paymentMethod, customer);
            this.isPayCompleted = true;
            this.payCompletedId = id;
            this.notifyPaymentComplete();
          }
        }
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
      } finally {
        this.hidePayLoading();
        this.isLoadingPayNow = false;
      }
    },
    async createApplication(id, paymentMethod, customer) {
      try {
        await ReapplyService.submitReapplyPaymentInfo(this.recordId, {
          id: id,
          foundApplication: this.foundApplication ?? null,
          recordId: this.recordId,
          amount: this.amount,
          currencyCode: this.currencyCode,
          email: this.email,
          name: this.fullName,
          firstName: this.firstName,
          lastName: this.lastName,
          phone: this.phone,
          address: {
            street: this.shippingAddress.line1 + (this.shippingAddress.line2 ? ', ' + this.shippingAddress.line2 : ''),
            postalCode: this.shippingAddress.postal_code ?? '',
            state: this.shippingAddress.state ?? '',
            city: this.shippingAddress.city ?? '',
            country: this.shippingAddress.country ?? ''
          },
          paymentMethod: paymentMethod,
          customer: customer ?? null,
          latest_charge: this.latest_charge,
          stageOption: this.stageOption,
          agent: this.agent
        });
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
      }
    },
    notifyPaymentComplete() {
      this.$emit('payment-complete');
    },
    showPayLoading() {
      this.isPayLoading = true;
    },
    hidePayLoading() {
      this.isPayLoading = false;
    },
    isEuropeanCountry(countryCode) {
      const europeanCountryCodes = [
        'AL',
        'AD',
        'AM',
        'AT',
        'AZ',
        'BY',
        'BE',
        'BA',
        'BG',
        'CH',
        'CY',
        'CZ',
        'DE',
        'DK',
        'EE',
        'ES',
        'FI',
        'FR',
        'GE',
        'GR',
        'HR',
        'HU',
        'IE',
        'IS',
        'IT',
        'KZ',
        'LI',
        'LT',
        'LU',
        'LV',
        'MC',
        'MD',
        'ME',
        'MK',
        'MT',
        'NL',
        'NO',
        'PL',
        'PT',
        'RO',
        'RU',
        'RS',
        'SE',
        'SI',
        'SK',
        'SM',
        'TR',
        'UA',
        'UK',
        'VA',
        'GI',
        'JE',
        'GG'
      ];
      return europeanCountryCodes.includes(countryCode.toUpperCase());
    },
    formatCountryNameToCountryCode(countryName) {
      let countryCode = '';
      switch (countryName) {
        case 'Ireland/Europe':
          countryCode = 'IE';
          break;
        case 'Canada':
          countryCode = 'CA';
          break;
        case 'USA/Rest of World':
          countryCode = 'US';
          break;
        case 'Australia':
          countryCode = 'AU';
          break;
        case 'New Zealand':
          countryCode = 'NZ';
          break;
        case 'South Africa':
          countryCode = 'ZA';
          break;
        default:
          countryCode = '';
      }
      return countryCode;
    }
  }
};
</script>
